// #551: Eigenes Browserfenster für EINE E-Mail (Route /mail-fenster/:id). Nutzt die normale
// Mailansicht samt aller Funktionen (Antworten, Ticket, Ablage …) im Vollbild — ohne Postfach,
// Seitenleiste und Pille. Änderungen meldet sie per BroadcastChannel ans Postfach-Fenster.
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { alsMailFensterNachricht, mailFensterPfad } from '../../../lib/emails/mailFenster';
import { IslandProvider, useIslandState } from '../../../components/island/IslandProvider';
import { FormContent } from '../../../components/island/states/FormContent';
import { EmailNavProvider } from './EmailNavContext';
import EmailListe from './EmailListe';

export default function MailFenster({ userProfile }: { userProfile?: any }) {
  const { id } = useParams();
  const navigate = useNavigate();
  // #572: Das Postfach schickt die nächste angeklickte Mail hierher, statt ein weiteres Fenster zu öffnen.
  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return;
    const k = new BroadcastChannel('immo-emails');
    k.onmessage = (e) => {
      const n = alsMailFensterNachricht(e.data);
      if (n?.typ === 'zeige') { navigate(mailFensterPfad(n.id), { replace: true }); window.focus(); }
    };
    return () => k.close();
  }, [navigate]);
  return (
    <IslandProvider>
      <EmailNavProvider>
        <div className="immo-flaeche flex min-h-screen w-full">
          <div aria-hidden className="immo-wand" />
          <main className="relative min-w-0 flex-1">
            {/* key: neue Mail = frisch aufgebaute Ansicht (lädt nur diese eine Mail) */}
            <EmailListe key={id} userProfile={userProfile} initialEmailId={id ?? null} fenster />
          </main>
          <FensterFormular />
        </div>
      </EmailNavProvider>
    </IslandProvider>
  );
}

// #570: Das Mailfenster hat keine Pille – per openForm geöffnete Formulare (Termin aus E-Mail, Kontakt
// hinzufügen) erscheinen hier als Fenster oben in der Mitte, mit demselben Inhalt wie in der Pille.
function FensterFormular() {
  const { mode, pageForm, formWidth, formContentHeight } = useIslandState();
  if (mode !== 'form' || !pageForm) return null;
  return (
    <div data-island className="fixed inset-0 flex justify-center" style={{ zIndex: 60, padding: 16, background: 'rgba(0,0,0,0.35)' }}>
      <div className="overflow-hidden" style={{
        width: formWidth ?? 520, maxWidth: '100%', height: formContentHeight ? Math.min(formContentHeight, 760) : 'auto', maxHeight: 'calc(100vh - 32px)',
        borderRadius: 32, boxShadow: '0 30px 70px -20px rgba(0,0,0,0.6)', background: '#141418',
      }}>
        <FormContent mobil={false} />
      </div>
    </div>
  );
}
